import { faEnvelope, faPhone } from "@fortawesome/pro-light-svg-icons";

import { T } from "@repo/transifex";
import { getErrorMessage } from "@repo/system";
import { useCurrentTill } from "~/api/tills/hooks/use-till-current";
import { ScreenIssue } from "~/components/screen/screen-issue";
import { useDeviceData } from "~/providers/app";
import { logger } from "~/services/logger";
import { useAuthStatus } from "~/providers/store/auth";
import { Button } from "~/components";
import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";
import { getSupportInfoFromCountryCode } from "~/utils/support/get-support-info-from-country-code";

export const NetworkIssueScreen = () => {
  const {
    data: till,
    fetchStatus: tillFetchStatus,
    error: tillError,
    refetch: refetchTill
  } = useCurrentTill();
  const { deviceId } = useDeviceData();
  const authStatus = useAuthStatus();

  const handleRetry = () => {
    logger.warn("User manually reloaded till due to no internet connection", {
      till_id: till?.id,
      till_device_id: till?.deviceId,
      device_id: deviceId,
      err: tillError,
      error: getErrorMessage(tillError)
    });
    refetchTill();
  };

  const { country } = useCurrentTillLocalisation();
  const { email, phone } = getSupportInfoFromCountryCode(country);

  if (authStatus === "unattended") {
    return (
      <button
        className="size-full"
        type="button"
        onClick={() => {
          logger.warn(
            "User manually reloaded till due to no internet connection",
            {
              till_id: till?.id,
              till_device_id: till?.deviceId,
              device_id: deviceId,
              err: tillError,
              error: getErrorMessage(tillError)
            }
          );
          refetchTill();
        }}
      >
        <ScreenIssue
          bottomSlot={
            <div className="flex flex-col gap-4">
              <ScreenIssue.Text className="font-bold text-interface-neutral-6">
                <T _str="Still having issues?" />
              </ScreenIssue.Text>

              <div className="flex gap-5">
                <Button
                  variant="light-green"
                  size="large"
                  className="rounded-full font-medium"
                  icon={faPhone}
                >
                  {phone}
                </Button>

                <Button
                  variant="light-green"
                  size="large"
                  className="rounded-full font-medium"
                  icon={faEnvelope}
                >
                  {email}
                </Button>
              </div>
            </div>
          }
        >
          <ScreenIssue.Title>
            <T _str="Tap anywhere to start" />
          </ScreenIssue.Title>
        </ScreenIssue>
      </button>
    );
  }

  return (
    <ScreenIssue>
      <ScreenIssue.Title>
        <T _str="No internet connection" />
      </ScreenIssue.Title>

      <ScreenIssue.Text>
        <T _str="Please check your network and try again." />
      </ScreenIssue.Text>

      <ScreenIssue.Button
        onClick={handleRetry}
        loading={tillFetchStatus === "fetching"}
      >
        <T _str="Reload" />
      </ScreenIssue.Button>
    </ScreenIssue>
  );
};
